export const IMAGE_URL = 'https://minio.coms.autosecure360.com/mkvision/student-avatar/';
